import { useQuery } from '@tanstack/react-query';
import { ICurrentSubscription } from '@clickersphere/core/entities/ISubscription';
import { ResponseError } from '@clickersphere/core/entities/ResponseError';
import BillingService from '@clickersphere/core/services/BillingService';
import { useBuildQueryKey } from '../useBuildQueryKey';
import { useUserMe } from '../user/useUserMe';

export const SUBSCRIPTION_QUERY_KEY = 'subscription';

export function useSubscription() {
  const { selectedTenantId } = useUserMe();
  const { buildQueryKey } = useBuildQueryKey();

  const { data, isLoading, isError, refetch } =
    useQuery<ICurrentSubscription | null>({
      queryKey: buildQueryKey(SUBSCRIPTION_QUERY_KEY),
      enabled: !!selectedTenantId,
      staleTime: 1000 * 60 * 2,
      refetchOnWindowFocus: true,
      refetchOnMount: true,
      retry: false,
      queryFn: async () => {
        try {
          return await BillingService.getCurrentSubscription();
        } catch (error) {
          if (error instanceof ResponseError && error.statusCode === 404) {
            return null;
          }
          throw error;
        }
      },
    });

  return {
    subscription: data?.subscription ?? null,
    plan: data?.plan ?? null,
    limits: data?.limits ?? null,
    usage: data?.usage ?? null,
    activeCoupon: data?.activeCoupon ?? null,
    isLoading,
    isError,
    refetch,
  };
}
